export default {
  site_name: "YoyBuy Asia",
  site_tagline: "Революционная система заказов через таблицы",
  hero_title_line1: "Yoybuy Sheet —",
  hero_title_line2: "Умная система заказов",
  hero_title_line3: "из Китая в Россию",
  hero_subtitle: "Профессиональный сервис spreadsheet-заказов для оптовых и розничных покупателей. Экономьте время и деньги с автоматизированной системой оформления.",
  hero_cta: "Открыть каталог",
  nav_yoybuy_sheet: "Yoybuy Sheet",
  nav_buy_now: "Buy It Now",
  categories_title: "Категории товаров",
  categories_subtitle: "14 направлений для заказа",
  categories_all: "Все категории",
  category_shoes: "Обувь",
  category_hoodies: "Худи / Свитера",
  category_tshirts: "Футболки",
  category_jackets: "Куртки",
  category_pants: "Штаны / Шорты",
  category_headwear: "Головные уборы",
  category_sets: "Комплекты",
  category_underwear: "Нижнее белье",
  category_jersey: "Джерси",
  category_accessories: "Аксессуары",
  category_bags: "Сумки",
  category_belts: "Ремни",
  category_perfumes: "Парфюмерия",
  category_other: "Прочее",
  seo_section_label: "Yoybuy Sheet — экспертная система заказов",
  seo_section_text: "Yoybuy Sheet представляет собой инновационную платформу для организации заказов товаров из Китая с использованием электронных таблиц. В отличие от традиционных методов оформления заказов через веб-интерфейс, наша spreadsheet-система позволяет одновременно обрабатывать сотни позиций, автоматически рассчитывать стоимость доставки и отслеживать статус каждого товара в режиме реального времени. Технология Yoybuy Sheet была разработана с учетом потребностей как частных покупателей, так и владельцев интернет-магазинов, которые нуждаются в эффективном инструменте для массовых закупок. Система интегрируется с Google Sheets и Microsoft Excel, что делает её доступной для пользователей с любым уровнем технической подготовки. Благодаря использованию Yoybuy Sheet, наши клиенты сокращают время на оформление заказов в среднем на 70% и получают полную прозрачность всех этапов — от выбора товара до его доставки на склад в России.",
  seo_read_more: "Читать подробнее",
  articles_title: "Гайды",
  articles_title_accent: "Yoybuy",
  articles_subtitle: "Полезные материалы по spreadsheet-заказам",
  articles_seo_tag: "SEO 2026",
  article_1_type: "Руководство",
  article_1_title: "Полное руководство по Yoybuy Sheet: как организовать заказы через таблицы",
  article_2_type: "Сравнение",
  article_2_title: "Yoybuy Sheet vs ручное оформление: почему таблицы эффективнее",
  article_3_type: "Шаблоны",
  article_3_title: "Бесплатные шаблоны spreadsheet для заказов из Китая",
  article_4_type: "Бизнес",
  article_4_title: "Как использовать Yoybuy Sheet для оптовых закупок и реселлинга",
  trust_label: "(Экспертный обзор)",
  trust_title_line1: "Yoybuy Sheet",
  trust_title_line2: "для оптовых закупок",
  trust_quote: "Yoybuy Sheet полностью изменил наш подход к закупкам из Китая. Раньше мы тратили часы на оформление каждого заказа вручную, а теперь вся команда работает в одной таблице, и процесс занимает минуты. Экономия времени колоссальная, а ошибки при оформлении практически исчезли.",
  trust_author: "Алексей Дмитриев",
  trust_role: "Владелец интернет-магазина, Москва",
  cta_section_label: "Прямая ссылка",
  cta_title_line1: "Перейти",
  cta_title_line2: "на Kaspreadsheet",
  cta_title_line3: "быстрый заказ",
  cta_right_title_line1: "Yoybuy Sheet",
  cta_right_title_line2: "Оформить заказ",
  cta_right_desc: "Готовы начать? Перейдите на Kaspreadsheet и оформите свой первый заказ через нашу spreadsheet-систему. Быстро, удобно и без лишних действий.",
  footer_catalog: "Каталог",
  footer_comparisons: "Сравнения",
  footer_guides: "Гайды",
  footer_templates: "Шаблоны",
  footer_link_home: "На главную",
  footer_link_article: "Руководство Yoybuy Sheet",
  footer_link_categories: "Категории товаров",
  footer_privacy: "Политика конфиденциальности",
  footer_copyright: "© 2026 YoyBuy Asia. Все права защищены.",
  notfound_title: "Страница не найдена",
  notfound_desc: "Перейдите на главную или свяжитесь с нами",
  back_to_home: "На главную",
  go_to_kaspreadsheet: "Перейти на Kaspreadsheet →",
  article_page_title: "Полное руководство по Yoybuy Sheet: как организовать заказы через таблицы",
  article_page_subtitle: "Пошаговое руководство для начинающих и опытных пользователей",
  article_breadcrumb_home: "Главная",
  article_breadcrumb_current: "Руководство по Yoybuy Sheet",
};